import imageDe from '../images/de/statistic.jpg';
import imageEn from '../images/en/statistic.jpg';
import imageFi from '../images/fi/statistic.jpg';
import imageFr from '../images/fr/statistic.jpg';
import imageIt from '../images/it/statistic.jpg';
import imageSv from '../images/se/statistic.jpg';

export const statistic = {
  de: function () {
    return imageDe;
  },
  en: function () {
    return imageEn;
  },
  fi: function () {
    return imageFi;
  },
  fr: function () {
    return imageFr;
  },
  it: function () {
    return imageIt;
  },
  se: function () {
    return imageSv;
  },
};